export const featuredProjectsInView = () => {
  const projects = document.querySelectorAll('.c-featured-project');
  if (projects.length === 0) {
    return;
  }

  // Clean up any previous listener to avoid duplicates after Swup.
  if (window.main?.featuredProjectsInviewCleanup) {
    window.main.featuredProjectsInviewCleanup();
  }

  window.main = window.main || {};

  const update = () => {
    projects.forEach((project) => {
      const rect = project.getBoundingClientRect();
      const position = project.getAttribute('data-position') || 'bottom-left';
      const viewportHeight = window.innerHeight || 0;
      let triggerPoint = 0;

      if (position.startsWith('top')) {
        triggerPoint = 0;
      } else if (position.startsWith('center')) {
        triggerPoint = viewportHeight * 0.75;
      } else {
        triggerPoint = viewportHeight * 0.5;
      }

      const isInView = rect.top <= triggerPoint && rect.bottom > 0;
      project.classList.toggle('is-in-view', isInView);
    });
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();

  window.main.featuredProjectsInviewCleanup = () => {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
  };
};
